import {
  OCPP_GET_CONFIGURATION_KEYS,
  OCPP_TRIGGER_MESSAGES,
} from '@evimo/types/constants/ocpp-charger-command';
import type {
  AssetCommandDefinition,
  AssetCommandUiId,
  AssetOcppCommandCategory,
} from './types';

export const OCPP_COMMAND_CATEGORIES: readonly {
  id: AssetOcppCommandCategory;
  labelKey: string;
}[] = [
  { id: 'basic', labelKey: 'detail.commands.categories.basic' },
  {
    id: 'configuration',
    labelKey: 'detail.commands.categories.configuration',
  },
  { id: 'diagnostics', labelKey: 'detail.commands.categories.diagnostics' },
] as const;

/**
 * Central UI registry. Add a future command here + backend DTO/registry entry.
 * Do not rewrite the Commands page for each new action.
 */
export const ASSET_COMMAND_DEFINITIONS: readonly AssetCommandDefinition[] = [
  {
    id: 'Reset',
    action: 'Reset',
    category: 'basic',
    requiresConfirmation: true,
    titleKey: 'detail.commands.reset.title',
    descriptionKey: 'detail.commands.reset.description',
    submitKey: 'detail.commands.reset.submit',
  },
  {
    id: 'ClearCache',
    action: 'ClearCache',
    category: 'basic',
    requiresConfirmation: true,
    titleKey: 'detail.commands.clearCache.title',
    descriptionKey: 'detail.commands.clearCache.description',
    submitKey: 'detail.commands.clearCache.submit',
  },
  {
    id: 'GetLocalListVersion',
    action: 'GetLocalListVersion',
    category: 'basic',
    requiresConfirmation: false,
    titleKey: 'detail.commands.getLocalListVersion.title',
    descriptionKey: 'detail.commands.getLocalListVersion.description',
    submitKey: 'detail.commands.getLocalListVersion.submit',
  },
  {
    id: 'GetConfiguration',
    action: 'GetConfiguration',
    category: 'configuration',
    requiresConfirmation: false,
    titleKey: 'detail.commands.getConfiguration.title',
    descriptionKey: 'detail.commands.getConfiguration.description',
    submitKey: 'detail.commands.getConfiguration.submit',
  },
  {
    id: 'UpdateHeartbeat',
    action: 'ChangeConfiguration',
    category: 'configuration',
    requiresConfirmation: true,
    titleKey: 'detail.commands.updateHeartbeat.title',
    descriptionKey: 'detail.commands.updateHeartbeat.description',
    submitKey: 'detail.commands.updateHeartbeat.submit',
  },
  {
    id: 'TriggerMessage',
    action: 'TriggerMessage',
    category: 'diagnostics',
    requiresConfirmation: false,
    titleKey: 'detail.commands.triggerMessage.title',
    descriptionKey: 'detail.commands.triggerMessage.description',
    submitKey: 'detail.commands.triggerMessage.submit',
  },
  {
    id: 'GetDiagnostics',
    action: 'GetDiagnostics',
    category: 'diagnostics',
    requiresConfirmation: false,
    titleKey: 'detail.commands.getDiagnostics.title',
    descriptionKey: 'detail.commands.getDiagnostics.description',
    submitKey: 'detail.commands.getDiagnostics.submit',
  },
] as const;

export const GET_CONFIGURATION_KEYS = OCPP_GET_CONFIGURATION_KEYS;
export const TRIGGER_MESSAGES = OCPP_TRIGGER_MESSAGES;

export function commandsForCategory(
  category: AssetOcppCommandCategory,
): readonly AssetCommandDefinition[] {
  return ASSET_COMMAND_DEFINITIONS.filter(
    (command) => command.category === category,
  );
}

export function findCommandDefinition(
  id: AssetCommandUiId,
): AssetCommandDefinition | undefined {
  return ASSET_COMMAND_DEFINITIONS.find((command) => command.id === id);
}
